<!--Title Section-->
<app-title-jumbo title="Position Keeping" comment="Track the positions of your portfolio and facilitate your management choices"></app-title-jumbo>

<div class="my-container">

<!--Universe Section-->
<section>
  <div class="container">
    <div class="offset-1 col-10">
      <mat-accordion *ngIf="currentCluster">
        <mat-expansion-panel [expanded]="false"
                             (opened)="panelOpenState = true"
                             (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ currentCluster.name }}
            </mat-panel-title>
            <mat-panel-description *ngIf="!panelOpenState">
              {{ currentCluster.investment_zone.name }} - {{ currentCluster.currency.name }} - {{ currentCluster.market_positions.name }}
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="row">
            <div class="col-12" style="line-height: 30px">
              <span> Investable Portfolio </span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <div class="w-100" style="border-top:1px dotted grey"></div>
              <span style="color: grey">Investment date</span>
              <span class="float-right">{{ currentCluster.investment_date | date:'d MMM y' }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <div class="w-100" style="border-top:1px dotted grey"></div>
              <span style="color: grey">Last update</span>
              <span class="float-right">{{ currentCluster.last_update | date:'d MMM y' }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey">Benchmark</span>
              <span class="float-right">{{ currentCluster.benchmark_name }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey">Market positions</span>
              <span class="float-right">{{ currentCluster.market_positions.name }}</span>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey">Investment zone</span>
              <span class="float-right">{{ currentCluster.investment_zone.name }}</span>
              <div class="w-100" style="border-bottom:1px dotted grey"></div>
            </div>
            <div class="col-6" style="line-height: 30px">
              <span style="color: grey">Currency</span>
              <span class="float-right">{{ currentCluster.currency.name }}</span>
              <div class="w-100" style="border-bottom:1px dotted grey"></div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <app-shadow-div col="8">
        <span style="color: rgb(94,187,75)">You must update the returns of your portfolio to use Monitoring features.</span>
      </app-shadow-div>

      <!-- Card deck -->
      <div class="card-deck mt-3">

        <!-- Card Performance & Risk -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/018.png"
                 alt="Card image cap">
            <a href="#!">
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='performanceRisk'? 'rgb(118,168,255)' : 'grey'}"><i class="fab fa-sellsy fa-lg"></i>&nbsp;&nbsp;&nbsp; Analytics</h4>
            <!--Text-->
            <p class="card-text">This section provides a quick view on performance & risk indicators since the implementation of the investable portfolio.</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='performanceRisk'">Analytics</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Performance & Risk -->

        <!-- Card Monitoring -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/019.png"
                 alt="Card image cap">
            <a href="#!">
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='turnover'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-hand-holding-usd fa-lg"></i>&nbsp;&nbsp;&nbsp; Turnover & Protection</h4>
            <!--Text-->
            <p class="card-text">This section summarizes relevant indicators on the turnover and the protection, if protection has been implemented.</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='turnover'">Protection</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Monitoring -->

        <!-- Card Rebalancing -->
        <div class="card mb-4">

          <!--Card image-->
          <div *ngIf="selectBlock==''" class="view overlay">
            <img class="card-img-top" src="assets/img/020.png"
                 alt="Card image cap">
            <a href="#!">
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>

          <!--Card content-->
          <div class="card-body">

            <!--Title-->
            <h4 class="card-title" [ngStyle]="{'color': selectBlock=='rebalancing'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-redo-alt fa-lg"></i>&nbsp;&nbsp;&nbsp; Exposure & Rebalancing</h4>
            <!--Text-->
            <p class="card-text">Having checked the exposure and the weights proposed, you may decide if you want to rebalance the strategy or wait another quarter.</p>
            <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
            <app-button (click)="selectBlock='rebalancing'">Rebalancing</app-button>

          </div>

          <!--Card footer-->
          <div *ngIf="selectBlock==''" class="card-footer text-right">
            <small *ngIf="currentCluster" class="text-muted">{{ currentCluster.inception_date | date:'d MMM y' }} — {{ currentCluster.last_date | date:'d MMM y' }}</small>
          </div>

        </div>
        <!-- Card Rebalancing -->

      </div>
      <!-- Card deck -->
    </div>
  </div>
</section>
<!--Universe Section-->

<!--Performance & Risk Section-->
<app-position-keeping-performance *ngIf="selectBlock=='performanceRisk'"></app-position-keeping-performance>
<!--Performance & Risk Section-->

<!--Turnover & Protection Section-->
<app-position-keeping-protection *ngIf="selectBlock=='turnover'"></app-position-keeping-protection>
<!--Turnover & Protection Section-->

<!--Rebalancing Section-->
<app-position-keeping-rebalancing *ngIf="selectBlock=='rebalancing'"></app-position-keeping-rebalancing>
<!--Rebalancing Section-->

</div>
